import React from 'react'
import HeaderOne from '../Components/Header/HeaderOne'
import Breadcrumb from '../Components/BreadCrumb/Breadcrumb'
import DestinationInner from '../Components/Destination/DestinationInner'
import FooterFour from '../Components/Footer/FooterFour'
import WhatsAppButton from '../Components/WA button/WAbutton';
import ScrollToTop from '../Components/ScrollToTop'

function Holidays() {
    return (
        <>
            <HeaderOne />
            <Breadcrumb
                title="Destination"
            />
            <DestinationInner />
            <FooterFour />
            <WhatsAppButton phone="971561678861" />

            <ScrollToTop />
        </>
    )
}

export default Holidays
